import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioDocumentWriteRequest {
    definitionId: string;
    values: OrdinaryObject;
    documentFileName: string;
    documentBase64: string;
}
